
import './App.scss';
import Home from "./Pages/home.jsx"
import Privacy from './Section/privacy/Privacy.jsx';
import { FloatingWhatsApp } from 'react-floating-whatsapp';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy-policy" element={<Privacy />} />
      </Routes>
      <a
        target="_blank"
        href="https://api.whatsapp.com/send/?phone=6282332091818&text=Halo%20Anthony,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Citra%20Garden%20Bintaro%20https://citra-garden-bintaro.id/&type=phone_number&app_absent=0"
      >
        <FloatingWhatsApp />
      </a>
    </Router>
  );
}

export default App;